export enum TipsDialogLogo {
  'Phone' = 'Phone',
  'Hand' = 'Hand',
}

export type TipsDialogData = {
  /** 标题 */
  title: string;
  /** 副标题 */
  desc?: string;
  /** 按钮文案 */
  btnText: string;
  /** logo类型 */
  logoType?: TipsDialogLogo;
  /** 点击按钮回调 */
  onBtnClickCb?: Function;
  /** 点击关闭按钮回调 */
  onCloseClickCb?: Function;
};

export enum C2CToastType {
  /** 提示活动已结束 */
  'ActEndTips' = 0,
  /** 受邀人已全部领券 */
  'C2CInviteeReceivedAll',
  /** 受邀人是本人 */
  'C2CInviteeSelf'
}
